// extracted by mini-css-extract-plugin
export var weWorkWithContainer = "WeWorkWith-module--we-work-with-container--1a1e1";